import { Property } from '../../types/property';

/*
 * Returns images 2nd, 3rd, 4th, & 5th property images if property has >= 5 images
 */

interface Image {
  url: string;
  blurHash: string;
  originalIndex: number;
}

const getThumbImages = (property: Property, total: number, locator?: string): Image[] => {
  if (property.images && property.images.length >= total) {
    const mLocator = locator || Object.keys(property.images[0].urls)[0];
    const images = [...property.images.slice(1)].sort((a, b) => (a.pinned ?? Infinity) - (b.pinned ?? Infinity));

    return images.slice(0, total).map((image) => {
      return {
        url: image.urls[mLocator] || image.url,
        blurHash: image.blurhash,
        originalIndex: property.images?.findIndex((i) => i.url === image.url) || 0,
      };
    });
  }

  return [];
};

export default getThumbImages;
